var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconamailrossa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_42",
    "data-name": "Raggruppa 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_21",
    "data-name": "Rettangolo 21",
    width: 28,
    height: 20,
    fill: "red"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_41",
    "data-name": "Raggruppa 41",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_81",
    "data-name": "Tracciato 81",
    d: "M28,3.3V16.7A3.3,3.3,0,0,1,24.7,20H3.3A3.3,3.3,0,0,1,0,16.7V3.3A3.28,3.28,0,0,1,.233,2.1l13.216,8.737a1,1,0,0,0,1.1,0l13.2-8.774A3.274,3.274,0,0,1,28,3.3M26.462.518A3.262,3.262,0,0,0,24.7,0H3.3A3.258,3.258,0,0,0,1.5.538L14,8.8Z",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamailrossa);
export default __webpack_public_path__ + "static/media/iconamailrossa.16d0dad067ee5cc39d1a90d7c98d482a.svg";
export { ForwardRef as ReactComponent };